<template>
    <div class="grid grid-cols-12 base-responsive-gap">
        <div
            class="col-span-12 md:col-span-6 flex items-center"
            :class="featured ? 'lg:col-span-5 lg:col-start-1' : 'lg:col-span-4 lg:col-start-2'"
        >
            <div :class="{ 'separator-border-top-line': !separatorBelowTitle }">
                <h2
                    :class="[
                        featured ? 'header-1' : 'header-2',
                        separatorBelowTitle ? 'border-b-[1px] border-gray-600 pb-4 mb-5' : 'mb-4',
                    ]"
                >
                    <T :t="titleKey" />
                </h2>
                <div class="md:hidden">
                    <StaticImage
                        :img-key="staticImageKey"
                        wrapper-class="sm:aspect-w-1 sm:aspect-h-1 rounded-full overflow-hidden"
                        image-class="w-full h-full object-cover "
                        class="text-center"
                    />
                </div>

                <div class="whitespace-pre-line mt-4 md:mt-0" :class="featured ? 'lead' : ''">
                    <T :t="descriptionKey" />
                </div>

                <div v-if="detailsTitleKey" class="mt-8 header-3"><T :t="detailsTitleKey" /></div>
                <div v-if="detailsDescriptionKey" class="whitespace-pre-line mt-2">
                    <T :t="detailsDescriptionKey" />
                </div>
                <div v-if="btnLabel && btnUrl" class="mt-8">
                    <Button :to="btnUrl" :label="btnLabel" />
                </div>
                <div v-if="secondaryBtnLabel && secondaryBtnUrl" class="mt-4">
                    <Button
                        :to="secondaryBtnUrl"
                        :label="secondaryBtnLabel"
                        class="p-button-secondary p-button-outlined"
                    />
                </div>
            </div>
        </div>
        <div
            class="col-span-12 sm:col-span-6 lg:col-span-6 mt-4 sm:mt-0 sm:mx-0 hidden md:block"
            :class="{ 'lg:col-start-7': featured }"
        >
            <div class="mx-auto">
                <StaticImage
                    :img-key="staticImageKey"
                    wrapper-class="sm:aspect-w-1 sm:aspect-h-1 rounded-full overflow-hidden"
                    image-class="w-full h-full object-cover "
                    class="text-center"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Type3Block',
    props: {
        featured: {
            type: Boolean,
            required: false,
            default: false,
        },
        separatorBelowTitle: {
            type: Boolean,
            required: false,
            default: false,
        },
        titleKey: {
            type: String,
            required: true,
        },
        descriptionKey: {
            type: String,
            required: true,
        },
        detailsTitleKey: {
            type: String,
            required: false,
            default: null,
        },
        detailsDescriptionKey: {
            type: String,
            required: false,
            default: null,
        },
        staticImageKey: {
            type: String,
            required: true,
        },
        btnLabel: {
            type: String,
            required: false,
            default: null,
        },
        btnUrl: {
            type: String,
            required: false,
            default: null,
        },
        secondaryBtnLabel: {
            type: String,
            required: false,
            default: null,
        },
        secondaryBtnUrl: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style></style>
